<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    const {class: cls = "", width = "24", height = "24"} = $props()
</script>

<svg class={twMerge("tw:text-cyprus tw:h-6 tw:w-6", cls)} width="{width}" height="{height}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
